import React from 'react';
import Cogeneration from './Cogeneration';
import Breadcrumb from './BreadCrumb';
function CogenerationPage() {
    return ( 
        <div className = "container-fluid">
        <Breadcrumb />
        <Cogeneration />
        </div>
     );
}

export default CogenerationPage ;